import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError, AxiosResponse } from "axios"

import { CertificateUpdateDto } from "@tfg/types/schemas/modules/traceability/commands/update-certificate/update-certificate.request.dto"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useUpdateCertificateMutation = (
  certificateId: string,
  options?: UseMutationOptions<AxiosResponse, AxiosError, CertificateUpdateDto>
) => {
  return useMutation(
    async (variables) => {
      return await httpClient.patch(
        `traceability/update-certificate/${certificateId}`,
        variables
      )
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(["certificates"])
        options?.onSuccess?.(data, variables, context)
      },
    }
  )
}
